/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect, useMemo } from 'react';
import { createResource, useResource, type RouteResource } from '@atlassian/react-resource-router';
import type {
	GitLabServiceTokenData,
	GitLabServiceTokenError,
	GitLabServiceTokenResponse,
} from './GitLabServiceTokenData.types.tsx';

export const jsmChangeManagementSettingsGitLabGatingResource: RouteResource<
	GitLabServiceTokenResponse | undefined
> = createResource<GitLabServiceTokenResponse | undefined>({
	type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
	getKey: () => 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
	getDataLoader: () =>
		import(
			/*
			webpackChunkName: "async-resource-jsm-change-management-settings-gitlab-gating",
			jiraSpaEntry: "async-resource-jsm-change-management-settings-gitlab-gating"
		*/
			'./getGitLabGatingData.tsx'
		),
	maxAge: __SERVER__ ? 0 : Number.MAX_SAFE_INTEGER,
	isBrowserOnly: true,
});

export const useGitLabGatingResource = (): {
	data: GitLabServiceTokenData | undefined;
	pending: boolean;

	error: GitLabServiceTokenError;
} => {
	const { data, loading, error, refresh } = useResource(
		jsmChangeManagementSettingsGitLabGatingResource,
	);

	useEffect(() => {
		if (!data && !loading && !error) {
			refresh();
		}
	}, [data, loading, error, refresh]);

	return useMemo(
		() => ({
			data: data?.data,
			pending: loading,
			// oxlint-disable-next-line typescript/consistent-type-assertions
			error: data?.error || (error as Error),
		}),
		[data, loading, error],
	);
};
